(() => {
    "use strict";
    var __webpack_modules__ = {
            9781: () => {
                document.addEventListener('theme:DOMContentLoaded', () => {
                    document.dispatchEvent(new Event('theme:collection:DOMContentLoaded'));
                    const big_products = document.querySelectorAll('[data-size]');
                    if(big_products.length) {
                        for(const el of big_products) {
                            el.parentElement.classList.add(el.dataset.size);
                        }
                    }
                });
            },
        },
        __webpack_exports__ = {};
    __webpack_modules__[9781]();
})();